import classNames from 'classnames';
import { useTranslation } from 'next-i18next';

const MultiCheckbox = ({ options, name, formDefinitionName, fixedName, ...props }) => {
  const { t } = useTranslation('common');
  const handleMultiOptionChange = (value) => {
    const array = [...props.value];

    if (array.includes(value)) {
      const index = array.indexOf(value);
      array.splice(index, 1);
    } else {
      array.push(value);
    }

    if (props.onChange) {
      const event = { target: { name, value: array.filter((n) => n) } };
      props.onChange(event);
    }
  };

  return (
    <div className="multicheckbox flex flex-col gap-03 md:flex-row">
      {options.map((option, index) => (
        <label key={name + '-' + index} className={classNames('multi-checkbox interactive-02', name)}>
          <input
            type="checkbox"
            className={classNames('input', props.value.includes(option.value) ? 'checked' : '')}
            id={name + '-' + option.value}
            name={name}
            disabled={props.disabled}
            value={option.value}
            checked={props.value.includes(option.value)}
            onChange={() => handleMultiOptionChange(option.value)}
          />
          {t(`forms.${formDefinitionName}.$${formDefinitionName}${fixedName}${option.value}`)}
        </label>
      ))}
    </div>
  );
};

export default MultiCheckbox;
